import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import {
  Divider,
  Drawer,
  Grid,
  IconButton,
  List,
  ListItem,
  ListItemText,
  Paper,
  Typography,
} from "@material-ui/core";
import { useSelector, useDispatch } from "react-redux";
import {
  openCommonPageModal,
  toggleDrawer,
} from "../../redux/action/utilActions";
import { useHistory } from "react-router-dom";
import { Close } from "@material-ui/icons";

import Accordion from "@material-ui/core/Accordion";
import AccordionSummary from "@material-ui/core/AccordionSummary";
import AccordionDetails from "@material-ui/core/AccordionDetails";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
const useStyles = makeStyles((theme) => ({
  drawer: {
    width: "100vw",
    flexShrink: 0,
    [theme.breakpoints.down("md")]: {
      width: "100vw",
      height: "100vh",
    },
  },
  logoContainer: {
    padding: theme.spacing(1),

    // height: "25vh",
    // width: "100%",
    // display: "flex",
    // alignItems: "center",
    // justifyContent: "center",
  },
  logo: {
    height: "8vh",
    // width: "100%",
  },
  root: {},
  closeIcon: {
    color: theme.palette.primary.main,
    fontSize: "2rem",
  },
  Accordion: {
    borderRadius: 0,
  },
  listText: {
    fontSize: "1rem",
    fontWeight: "500",
  },
  List: {
    width: "100%",
  },
  AddPanchayatBtn: {
    backgroundColor: theme.palette.primary.main,
    "&:focus": {
      backgroundColor: theme.palette.primary.main,
    },
    "&:active": {
      backgroundColor: theme.palette.primary.main,
    },
  },
  AddPanchayaText: {
    color: "white",
  },
}));

const NavLinksDrawer = ({ data, addBtnTitle, logoUrl }) => {
  const classes = useStyles();
  const history = useHistory();
  const dispatch = useDispatch();
  const drawerOpen = useSelector((state) => state.util.drawerOpen);
  const handleAddLink = (title, link) => {
    dispatch(toggleDrawer());
    dispatch(openCommonPageModal({ title, link: "addpanchayat" }));
  };
  const logo = "/images/logo/logo.png";
  const handleNavigate = (
    link,
    extenral,
    isModal,
    title,
    datalink,
    postlink
  ) => {
    dispatch(toggleDrawer());
    if (isModal) {
      return dispatch(openCommonPageModal({ title, link, datalink, postlink }));
    }
    if (extenral) {
      return window.open(link, "_blank");
    }

    history.push(`/${link}`);
  };

  const logoNavigate = () => {
    history.push("/");
    dispatch(toggleDrawer());
  };

  const renderAccrodion = (nav, index) => {
    const link = nav?.link;
    const external = nav?.external;
    const title = nav.title;
    const isModal = nav?.isModal;
    const postlink = nav?.postlink;
    const datalink = nav?.datalink;
    return (
      <div key={index}>
        <Accordion square elevation={0}>
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            className={classes.Accordion}
          >
            <Typography className={classes.sublistTetx}>{title}</Typography>
          </AccordionSummary>
          <AccordionDetails className={classes.AccordionDetails}>
            <List
              className={classes.List}
              disablePadding
              component={Paper}
              variant="outlined"
            >
              {nav?.children.map((child, index) => {
                return renderItem(child, index, true);
              })}
            </List>
          </AccordionDetails>
        </Accordion>
        <Divider />
      </div>
    );
  };

  const AddPanchayat = () => {
    return (
      <ListItem
        button
        onClick={() => handleAddLink(addBtnTitle)}
        className={classes.AddPanchayatBtn}
      >
        <ListItemText
          primary={
            <Typography className={classes.AddPanchayaText}>
              {addBtnTitle}
            </Typography>
          }
        />
      </ListItem>
    );
  };
  const renderItem = (nav, index, sub) => {
    const link = nav?.link;
    const external = nav?.external;
    const title = nav.title;
    const isModal = nav?.isModal;
    const postlink = nav?.postlink;
    const datalink = nav?.datalink;

    return !nav?.children || nav.children.length === 0 ? (
      <>
        <ListItem
          button
          key={index}
          onClick={() => {
            handleNavigate(link, external, isModal, title, datalink, postlink);
          }}
        >
          <ListItemText
            primary={
              <Typography
                variant={sub ? classes.sublistTetx : classes.listText}
              >
                {title}
              </Typography>
            }
          />
        </ListItem>
        <Divider />
      </>
    ) : (
      renderAccrodion(nav, index)
    );
  };
  return (
    <div className={classes.root}>
      <Drawer
        variant="temporary"
        anchor=""
        open={drawerOpen}
        className={classes.drawer}
        onClose={() => {
          dispatch(toggleDrawer());
        }}
      >
        <Grid container>
          <Grid
            container
            alignItems="center"
            justify="space-between"
            item
            direction="row"
            lg={12}
            md={12}
            sm={12}
            xs={12}
          >
            <Grid item className={classes.logoContainer}>
              <img
                src={logoUrl || logo}
                className={classes.logo}
                onClick={() => logoNavigate()}
              />
            </Grid>

            <Grid item className={classes.logoContainer}>
              <IconButton onClick={() => dispatch(toggleDrawer())}>
                <Close className={classes.closeIcon} />
              </IconButton>
            </Grid>
          </Grid>
          <Grid item lg={12} md={12} xs={12} sm={12}>
            <Divider />
          </Grid>

          <Grid item lg={12} sm={12} xs={12} md={12}>
            <AddPanchayat />
            {data?.map((nav, index) => {
              return renderItem(nav, index);
            })}
          </Grid>
        </Grid>
      </Drawer>
    </div>
  );
};
export default NavLinksDrawer;

// import React from "react";
// import { makeStyles } from "@material-ui/core/styles";
// import {
//   Divider,
//   Drawer,
//   Grid,
//   IconButton,
//   List,
//   ListItem,
//   ListItemText,
//   Paper,
//   Typography,
// } from "@material-ui/core";
// import { useSelector, useDispatch } from "react-redux";
// import {
//   openCommonPageModal,
//   toggleDrawer,
// } from "../../redux/action/utilActions";
// import { useHistory } from "react-router-dom";
// import { Close } from "@material-ui/icons";

// import Accordion from "@material-ui/core/Accordion";
// import AccordionSummary from "@material-ui/core/AccordionSummary";
// import AccordionDetails from "@material-ui/core/AccordionDetails";
// import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
// const useStyles = makeStyles((theme) => ({
//   drawer: {
//     width: "100vw",
//     flexShrink: 0,
//     [theme.breakpoints.down("md")]: {
//       width: "100vw",
//       height: "100vh",
//     },
//   },
//   logoContainer: {
//     padding: theme.spacing(1),

//     // height: "25vh",
//     // width: "100%",
//     // display: "flex",
//     // alignItems: "center",
//     // justifyContent: "center",
//   },
//   logo: {
//     height: "8vh",
//     // width: "100%",
//   },
//   root: {},
//   closeIcon: {
//     color: theme.palette.primary.main,
//     fontSize: "2rem",
//   },
//   Accordion: {
//     borderRadius: 0,
//   },
//   listText: {
//     fontSize: "1rem",
//     fontWeight: "500",
//   },
//   List: {
//     width: "100%",
//   },
//   AddPanchayatBtn: {
//     backgroundColor: theme.palette.primary.main,
//     "&:focus": {
//       backgroundColor: theme.palette.primary.main,
//     },
//     "&:active": {
//       backgroundColor: theme.palette.primary.main,
//     },
//   },
//   AddPanchayaText: {
//     color: "white",
//   },
// }));

// const NavLinksDrawer = ({ data, addBtnTitle }) => {
//   const classes = useStyles();
//   const history = useHistory();
//   const dispatch = useDispatch();
//   const drawerOpen = useSelector((state) => state.util.drawerOpen);
//   const handleAddLink = (title, link) => {
//     dispatch(toggleDrawer());
//     dispatch(openCommonPageModal({ title, link: "addpanchayat" }));
//   };
//   const logo = "/images/logo/logo.png";
//   const handleNavigate = (
//     link,
//     extenral,
//     isModal,
//     title,
//     datalink,
//     postlink
//   ) => {
//     dispatch(toggleDrawer());

//     if (isModal) {
//       return dispatch(openCommonPageModal({ title, link, datalink, postlink }));
//     }
//     if (extenral) {
//       return window.open(link, "_blank");
//     }
//     history.push(link);
//   };

//   const logoNavigate = () => {
//     history.push("/");
//     dispatch(toggleDrawer());
//   };
//   const renderAccrodion = (nav, index) => {
//     const link = nav?.link;
//     const external = nav?.external;
//     const title = nav.title;
//     const isModal = nav?.isModal;
//     const postlink = nav?.postlink;
//     const datalink = nav?.datalink;
//     return (
//       <div key={index}>
//         <Accordion square elevation={0}>
//           <AccordionSummary
//             expandIcon={<ExpandMoreIcon />}
//             className={classes.Accordion}
//           >
//             <Typography className={classes.sublistTetx}>{title}</Typography>
//           </AccordionSummary>
//           <AccordionDetails className={classes.AccordionDetails}>
//             <List
//               className={classes.List}
//               disablePadding
//               component={Paper}
//               variant="outlined"
//             >
//               {nav.children.map((child, index) => {
//                 return renderItem(child, index, true);
//               })}
//             </List>
//           </AccordionDetails>
//         </Accordion>
//         <Divider />
//       </div>
//     );
//   };

//   const AddPanchayat = () => {
//     return (
//       <ListItem
//         button
//         onClick={() => handleAddLink(addBtnTitle)}
//         className={classes.AddPanchayatBtn}
//       >
//         <ListItemText
//           primary={
//             <Typography className={classes.AddPanchayaText}>
//               {addBtnTitle}
//             </Typography>
//           }
//         />
//       </ListItem>
//     );
//   };
//   const renderItem = (nav, index, sub) => {
//     const link = nav?.link;
//     const external = nav?.external;
//     const title = nav.title;
//     const isModal = nav?.isModal;
//     const postlink = nav?.postlink;
//     const datalink = nav?.datalink;

//     return !nav?.children || nav.children.length === 0 ? (
//       <>
//         <ListItem
//           button
//           key={index}
//           onClick={() => {
//             handleNavigate(link, external, isModal, title, datalink, postlink);
//           }}
//         >
//           <ListItemText
//             primary={
//               <Typography
//                 variant={sub ? classes.sublistTetx : classes.listText}
//               >
//                 {title}
//               </Typography>
//             }
//           />
//         </ListItem>
//         <Divider />
//       </>
//     ) : (
//       renderAccrodion(nav, index)
//     );
//   };
//   return (
//     <div className={classes.root}>
//       <Drawer
//         variant="temporary"
//         anchor=""
//         open={drawerOpen}
//         onClose={() => {
//           dispatch(toggleDrawer());
//         }}
//       >
//         <Grid container>
//           <Grid
//             container
//             alignItems="center"
//             justify="space-between"
//             item
//             direction="row"
//             lg={12}
//             md={12}
//             sm={12}
//             xs={12}
//           >
//             <Grid item className={classes.logoContainer}>
//               <img
//                 src={logo}
//                 className={classes.logo}
//                 onClick={() => logoNavigate()}
//               />
//             </Grid>

//             <Grid item className={classes.logoContainer}>
//               <IconButton onClick={() => dispatch(toggleDrawer())}>
//                 <Close className={classes.closeIcon} />
//               </IconButton>
//             </Grid>
//           </Grid>
//           <Grid item lg={12} md={12} xs={12} sm={12}>
//             <Divider />
//           </Grid>

//           <Grid item lg={12} sm={12} xs={12} md={12}>
//             <AddPanchayat />
//             {data?.map((nav, index) => {
//               return renderItem(nav, index);
//             })}
//           </Grid>
//         </Grid>
//         {/* <div className={classes.drawer}>
//           <div className={classes.logoContainer}>
//             <img src={logo} className={classes.logo} />
//           </div>
//           <Divider />
//           <List>
//             {data?.map((nav, index) => {
//               return renderItem(nav, index);
//             })}
//             <Divider />
//           </List>
//         </div> */}
//       </Drawer>
//     </div>
//   );
// };
// export default NavLinksDrawer;
